import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { join } from "../data/career";

{
  /*const certificates = [
  { src: c8, title: "GST" },
  { src: c1, title: "ISO Certified" },
  { src: c2, title: "ISO Certified" },
  { src: c3, title: "Certificate of Compliance" },
  { src: c4, title: "CE Mark Certificate" },
  { src: c5, title: "FCC Certificate" },
  { src: c6, title: "RoHS Certificate" },
  { src: c7, title: "Factory License" },
];*/
}

const Career = () => {
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleImageClick = (src) => {
    setFullscreenImage(src);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(event.target);

    try {
      const response = await fetch(
        "https://api.mytimewatch.com/api/career/submit",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        setIsSubmitting(false);
        event.target.reset();
        navigate("/thank-you");
      } else {
        navigate("/error");
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <>
      <div
        className="p-5 text-center bg-image"
        style={{
          backgroundImage:
            "url('https://timewatch.co.in/images/career-image.png')",
          height: 600,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className=" text-center">
          <h1 className="mb-3 fw-bold text-black">
            Join <span style={{ color: "#D63438" }}>Time</span>
            <span style={{ color: "#6E7073" }}>Watch</span> - Where
          </h1>
          <h4 className="mb-3 fw-bold">
            <span style={{ color: "#F14144" }}>Innovation </span>
            <span color="#292828">Meets</span>
            <span style={{ color: "#f14144" }}> Opportunity</span>
          </h4>
          <button
            className="btn btn-lg fw-bold"
            onClick={() =>
              document
                .getElementById("jobApplicationForm")
                .scrollIntoView({ behavior: "smooth" })
            }
            role="button"
            style={{
              backgroundColor: "#f14144",
              color: "white",
              textDecoration: "none",
              border: "2px solid #f14144",
              borderRadius: "50px",
            }}
          >
            Explore Opportunities
          </button>
        </div>
      </div>
      <div className="container mt-5 text-center" id="jobApplicationForm">
        <h2 className="mb-5 fw-bold text-black">Why Join Us?</h2>
        <div className="row justify-content-center">
          {join.map((item, index) => (
            <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
              <img
                src={require(`../assets/icons/${item.icon}`)}
                alt={item.heading}
                className="mb-3 img-fluid"
                style={{ maxWidth: "80px", height: "auto", margin: "auto" }}
              />
              <h4 className="text-black fw-bold mb-2">{item.heading}</h4>
              <p
                className="fst-italic text-secondary"
                style={{ fontSize: "14px" }}
              >
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="container py-5 mt-5 mb-5 d-flex justify-content-center">
        <div className="row w-100 justify-content-center">
          {/* Centered Form */}
          <div className="col-lg-6 col-md-8 col-sm-10">
            <div className=" p-4 rounded shadow">
              <h2 className="text-center mb-4">Empower Your Career Path</h2>
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="mb-3">
                  <label htmlFor="role" className="form-label fw-bold">
                    Role Applying For{" "}
                    <span style={{ color: "#f14144" }}>*</span>
                  </label>
                  <input
                    id="role"
                    name="role"
                    className="form-control"
                    placeholder="Role Applying For..."
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label fw-bold">
                    Full Name <span style={{ color: "#f14144" }}>*</span>
                  </label>
                  <input
                    id="name"
                    name="name"
                    className="form-control"
                    placeholder="Full Name..."
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="phone" className="form-label fw-bold">
                    Contact Number <span style={{ color: "#f14144" }}>*</span>
                  </label>
                  <input
                    id="phone"
                    name="phone"
                    className="form-control"
                    placeholder="Contact Number..."
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label fw-bold">
                    Email Address <span style={{ color: "#f14144" }}>*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    className="form-control"
                    placeholder="Email Address..."
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="location" className="form-label fw">
                    Location <span style={{ color: "#f14144" }}>*</span>
                  </label>
                  <input
                    id="location"
                    name="location"
                    className="form-control"
                    placeholder="City/State..."
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="coverLetter" className="form-label fw-bold">
                    Cover Letter <span style={{ color: "#f14144" }}>*</span>
                  </label>
                  <textarea
                    id="coverLetter"
                    name="coverLetter"
                    rows="4"
                    className="form-control"
                    placeholder="Cover Letter..."
                    required
                  ></textarea>
                </div>

                <div className="mb-3">
                  <label htmlFor="resume" className="form-label fw-bold">
                    Resume (PDF) <span style={{ color: "#f14144" }}>*</span>
                  </label>
                  <input
                    type="file"
                    id="resume"
                    name="resume"
                    className="form-control"
                    accept=".pdf"
                    required
                  />
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-danger"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "On it's way..." : "Apply Now"}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="mt-5">
            <h1 className="fw-bold text-black">Find Us Here!</h1>
            <div className="iframe-container border border-secondary rounded overflow-hidden mt-5">
              <iframe
                src="https://storage.googleapis.com/maps-solutions-3lh94eogde/locator-plus/pk8j/locator-plus.html"
                width="100%"
                height="500"
                style={{ border: 0 }}
                loading="lazy"
                title="Our Locations"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Career;
